import React from 'react';

// add commas for input boxes
const formatWithCommas = (value?: number) => {
  if (!value && value !== 0) return '';
  return `$${value.toLocaleString()}`;
};

interface ListPriceBodyProps {
  minLocal: number | undefined;
  maxLocal: number | undefined;
  onMinChange: (val: string) => void;
  onMaxChange: (val: string) => void;
}

export const ListPriceBody = ({
  minLocal,
  maxLocal,
  onMinChange,
  onMaxChange
}: ListPriceBodyProps) => {
  return (
    <div className="flex items-center space-x-2">
      <input
        type="text"
        placeholder="Enter min"
        value={minLocal !== undefined ? formatWithCommas(minLocal) : ''}
        onChange={(e) => onMinChange(e.target.value)}
        className="w-full border rounded px-3 py-2 focus:outline-none focus:border-blue-500 text-center"
      />
      <span className="text-gray-600">-</span>
      <input
        type="text"
        placeholder="Enter max"
        value={maxLocal !== undefined ? formatWithCommas(maxLocal) : ''}
        onChange={(e) => onMaxChange(e.target.value)}
        className="w-full border rounded px-3 py-2 focus:outline-none focus:border-blue-500 text-center"
      />
    </div>
  );
};
